import React from 'react'
import FirstMain from '../Subcomponents/FirstMain'
import Fourth from '../Subcomponents/Fourth'
import SecondMain from '../Subcomponents/SecondMain'
import Third from '../Subcomponents/Third'
import Footer from '../Subcomponents/Footer'
function MainBar() {
  return (
    <>
    <FirstMain/>
    <SecondMain/>
    <Third />
    <Fourth/>
    <Footer/>
    </>
  )
}

export default MainBar